module.exports = __webpack_public_path__ + "static/img/legend_spanish.dd62cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_spanish.png
// module id = vqDR
// module chunks = 94